// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8e92C","veil":"styles_veil__cLmr8"};